import Api from "../utils/axios";

const earningApis = {
  getAllOrdersEarning: (payload = {}, search = "") =>
    Api.post(`order/get-all-earning?search=${search}`, payload),

  getAllVendorPayouts: (payload = {}, search = "") =>
    Api.post(`vendor/get-vendor-payouts?search=${search}`, payload),

  getVendorPayoutById: (payload = {}, search = "") =>
    Api.post(`vendor/get-vendor-payout-by-id?search=${search}`, payload),

  getVendorPayoutDetailsById: (payoutId, payload = {}, search = "") =>
    Api.post(
      `vendor/get-vendor-payout-details-by-id/${payoutId}?search=${search}`,
      payload
    ),
};

export const foodEarningApis = {
  getAllOrdersEarning: (payload = {}, search = "") =>
    Api.post(`food-order/get-all-earning?search=${search}`, payload),
};

export default earningApis;
